import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography, TextField , Box  } from "@mui/material";
import {EditOutlined ,DeleteOutline } from "@mui/icons-material";
import { ContentCopyOutlined, TableChartOutlined, DescriptionOutlined, PictureAsPdfOutlined, FileDownloadOutlined } from "@mui/icons-material";
import { DataGrid , GridToolbar } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";
import { useFormik } from "formik";
import Pagination from "@mui/material/Pagination";

//Services
import servicetypeapi from "Services/ZoneServicefare";

//Modals
import ServicetypeAddModal from "Pages/Modals/ServicetypeZonefare/Create";
import ServicetypeUpdateModal from "Pages/Modals/ServicetypeZonefare/Update";
import ServicetypeDeleteDialog from "Pages/Modals/ServicetypeZonefare/Delete";

const ServicetypeZonefare = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  //

  const [row, setRow] = useState([]);
  const [zonedata, setzonedata] = useState([]);
  const [customerId, setCustomerId] = useState("");

  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);

  //Modals

  const [addServicetypeModal, setaddServicetypeModal] = useState(false);

  const handleOpenAddServiceModal = () => {
    setaddServicetypeModal(true);
  };

  const handleCloseAddServiceModal = () => {
    setaddServicetypeModal(false);
    getServicetype();
  };

  const [updateServicetypeModal, setupdateServicetypeModal] = useState(false);

  const handleOpenUpdateServiceModal = (id) => {
    setCustomerId(id);
    setupdateServicetypeModal(true);
  };

  const handleCloseUpdateServiceModal = () => {
    setupdateServicetypeModal(false);
    getServicetype();
  };
  
  const [deleteServicetypeModal, setdeleteServicetypeModal] = useState(false);

  const handleOpenDeleteServiceModal = (id) => {
    setCustomerId(id);
    setdeleteServicetypeModal(true);
  };

  const handleCloseDeleteServiceModal = (row) => {
    setdeleteServicetypeModal(false);
    getServicetype();
  };

  // Get Services list api
  const getServicetype = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      console.log('newdaa',res.data);
      dispatch(hideLoader());
      if (res?.status === 200) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data || []);
        setzonedata(res?.data?.data?.zonefaredata || []);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    servicetypeapi.getzoneServicesList({ page, limit: pageSize })
      .then(onSuccess, onFailure);
  }, [page, pageSize]);

  useEffect(() => {
    getServicetype();
  }, [getServicetype]);


  const handleCopy = () => {

       // Define column widths
       const columnWidths = [5, 15 , 15 ]; // Adjust widths as needed
  
       // Helper function to pad text to the desired width
       const padText = (text, width) => {
         return (text ?? "").toString().padEnd(width, " ");
       };
       // Create table header
       const header = [
         padText("S.NO", columnWidths[0]),
         padText("SERVICE TYPE", columnWidths[1]),
         padText("SERVICE STATUS", columnWidths[2]),
       ].join("");
     
       // Create table rows
       const rows = dataRows
         .map((row) =>
           [
             padText(row.sno, columnWidths[0]),
             padText(row.serviceType, columnWidths[1]),
             padText(row.status?"Active":"Inactive", columnWidths[2]),
           ].join("")
         )
         .join("\n");
     
       // Combine header and rows
       const formattedContent = [header, rows].join("\n");
     
       // Copy to clipboard
       navigator.clipboard.writeText(formattedContent).then(() => {
         alert("Table copied to clipboard!");
       });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "ServiceList.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "ServiceList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,
      row.serviceType,
      row.status?"Active":"Inactive",
    ]);
    doc.autoTable({
      head: [["S.No", "Service Type" , "Status"]],
      body: tableData,
    });
    doc.save("ServiceList.pdf");
  };

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const dataRows = _.map(zonedata || [], (data, index) => ({
    id: zonedata[index]?._id,
    sno: calculateSno(page, pageSize, index),
  
    _id: zonedata[index]?._id,
  
    sourceAddress:
      zonedata[index]?.SourceAddress?.locationName || "",
  
    destination:
      zonedata[index]?.DestinationAddress?.locationName || "",
  
    reverse:
      zonedata[index]?.ReverseLocation ? "YES" : "NO",
  
    serviceType:
      zonedata[index]?.zoneserviceTypeId?.serviceName || "",
  
    status: zonedata[index]?.isActive,
  
    row: data,
  }));
 console.log(dataRows)
 

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "SOURCE ADDRESS":row.sourceAddress,
    "DESTINATION ADDRESS":row.destination,
    "REVERSE":row.reverse,
    "SERVICE TYPE": row.serviceType,
    "STATUS": row.status ? "Active":"Inactive",
  }));
  
  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex:0.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "sourceAddress",
      headerName: "SOURCE ADDRESS",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
<div>
                  {/* <Box
                  component="img"
                  sx={{
                  width: 50,
                  height: 50,
                  borderRadius: "25%",
                  objectFit: "cover",
                  boxShadow: 3,
                  }}
                  src={params?.row?.serviceImage}
                  alt="Sample Image"
                  /> */}
                  <Typography variant="body2">{params?.row?.sourceAddress}</Typography>
</div>
          </>
        );
      },
    },
    {
      field: "destination",
      headerName: "DESTINATION ADDRESS",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.destination}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "reverse",
      headerName: "REVERSE",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.reverse}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "serviceType",
      headerName: "Service Type",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.serviceType}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex:1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <> 
          <Button variant="contained">{params?.row?.status ? "active":"inactive"}</Button>          
          </>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex:1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.iconsWrapper}>
              <section className={classes.editIcon}>
                <EditOutlined
                  onClick={() =>
                    handleOpenUpdateServiceModal(params?.row?._id)
                  }
                />
                  <Typography variant="subtitle2" gutterBottom className={classes.actiontypo}>
                    Edit
                   </Typography>
              </section>
              <section className={classes.deleteIcon}>
                <DeleteOutline
                  onClick={() =>
                    handleOpenDeleteServiceModal(params?.row?._id)
                  }
                />
                <Typography variant="subtitle2" gutterBottom className={classes.actiontypo}>
                    Delete
                   </Typography>
              </section>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Grid container className={classes.root}>
      {/* <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<ContentCopyOutlined />} onClick={handleCopy}>
            COPY
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<TableChartOutlined />} onClick={handleDownloadExcel}>
            EXCEL
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<DescriptionOutlined />} onClick={handleDownloadCSV}>
            CSV
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<PictureAsPdfOutlined />} onClick={handleDownloadPDF}>
            PDF
          </Button>
        </Grid> */}
        <Grid item xs={8} md={8} lg={8} xl={8} className={classes.funBtn}>
          <Button variant="contained" onClick={handleOpenAddServiceModal}>
            Add Zone Wise Fare 
          </Button>
        </Grid>
        <Grid item xs={12} >
          <section  className={classes.dataGridTable}>
            <DataGrid
              //getRowId={(row) => row._id}
              rows={dataRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
                setPage(1);
              }}
              onPageChange={(newPage) => handlePageChange(newPage)}
              rowsPerPageOptions={[5, 10, 25, 50]}
              pagination
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px" }}
              paginationMode="server"
              rowCount={totalPages}
              columnResizeMode="onDrag" // Allows resizing
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                },
              }}
            />
          </section>
        </Grid>
      </Grid>
      <ServicetypeAddModal
        openDialog={addServicetypeModal}
        handleClose={handleCloseAddServiceModal}
      ></ServicetypeAddModal>
      <ServicetypeUpdateModal
        openDialog={updateServicetypeModal}
        id={customerId}
        handleClose={handleCloseUpdateServiceModal}
      ></ServicetypeUpdateModal>
      <ServicetypeDeleteDialog
        openDialog={deleteServicetypeModal}
        id={customerId}
        handleClose={handleCloseDeleteServiceModal}
      ></ServicetypeDeleteDialog>
    </>
  );
};

export default ServicetypeZonefare;
